export default "__VITE_ASSET__ebe0950f__"